import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Column, TextButton, useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { CustomPageTextViewer } from '~/components/CustomPageTextViewer/CustomPageTextViewer';
import { PdfViewerModal } from '~/components/PdfViewerModal/pdfViewerModal';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { agreementPages } from '~/models/custom-page/model';
import { AgreementViewCard } from '../CommonComponents';
export const GetCustomPagesInAgreementTID = (parentTestId)=>getTestIds(parentTestId);
export const CustomPagesInAgreement = (param)=>{
    let { relationship, testId } = param;
    const { t: viewTexts } = useLocaleKeys('pages.agreementMinisite.agreementView');
    const { t: pdfUploadTexts } = useLocaleKeys('customPages.pdfUpload');
    const { api } = useStoreActions();
    const { showModal } = useOverlayContext();
    const testIds = useMemo(()=>GetCustomPagesInAgreementTID(testId), [
        testId
    ]);
    const pages = useMemo(()=>{
        var _relationship_customPages;
        return agreementPages((_relationship_customPages = relationship.customPages) !== null && _relationship_customPages !== void 0 ? _relationship_customPages : []);
    }, [
        relationship.customPages
    ]);
    const openPdfViewer = (page)=>{
        showModal({
            biName: 'custom_page_pdf_preview_modal',
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(PdfViewerModal, {
                    title: pdfUploadTexts.previewModalTitle(),
                    pdfUniqueName: page.pdf.pdfName,
                    getFileUrl: async (pdfUniqueName)=>{
                        const result = await api.customPage.getDownloadUrl(relationship.vendor.id, pdfUniqueName);
                        return result.url;
                    },
                    onClose: dismissModal,
                    testId: testIds.CustomPagesInAgreementTestIds.PdfViewerModal()
                });
            }
        });
    };
    if (pages.length === 0) {
        return null;
    }
    const renderPageContent = (page)=>{
        switch(page.type){
            case 'text':
                return /*#__PURE__*/ _jsx(Box, {
                    testId: testIds.CustomPagesInAgreementTestIds.TextPage(page.id),
                    children: /*#__PURE__*/ _jsx(CustomPageTextViewer, {
                        sourceId: relationship.id,
                        textId: page.text.textId
                    })
                });
            case 'pdf':
                return /*#__PURE__*/ _jsx(Box, {
                    testId: testIds.CustomPagesInAgreementTestIds.PdfPage(page.id),
                    children: /*#__PURE__*/ _jsx(TextButton, {
                        testId: testIds.CustomPagesInAgreementTestIds.PdfViewButton(page.id),
                        bi: {
                            name: 'view_custom_page_pdf',
                            data: {
                                page_id: page.id
                            }
                        },
                        onClick: ()=>openPdfViewer(page),
                        children: viewTexts.view()
                    })
                });
            case 'video':
                return null;
        }
        const _exhaustive = page;
        return _exhaustive;
    };
    return /*#__PURE__*/ _jsx(Column, {
        gap: 16,
        testId: testIds.CustomPagesInAgreementTestIds.Root(),
        children: pages.map((page)=>/*#__PURE__*/ _jsx(Column, {
                testId: testIds.CustomPagesInAgreementTestIds.PageWrapper(page.id),
                children: /*#__PURE__*/ _jsx(AgreementViewCard, {
                    headTitle: page.pageTitle,
                    children: renderPageContent(page)
                })
            }, page.id))
    });
};
